export default __webpack_public_path__ + "98ff955021a9a4965b3aef28352299ae.jpg";